import moment from 'moment';
import resourceMixin from '@core/Util/Mixins/resources';
import {RouteNames} from '@modules/AudienceManager/constants';

import Concept from './Concept/concept.vue';
import Published from './Published/published.vue';
import Inactive from './Inactive/inactive.vue';

import {createNamespacedHelpers} from "vuex";
const { mapActions, mapState } = createNamespacedHelpers('audienceManager/overview');

export default {
    name: 'audience-manager-overview',
    mixins: [resourceMixin],
    components: {
        Concept,
        Published,
        Inactive
    },
    async created() {
        await this.getAudiences();
        await this.getChannels();
    },
    methods: {
        async reload() {
            await this.getAudiences();
        },
        htmlDateField(date) {
            return `<span hidden>${moment(date).format('YYYY MM DD')}</span>
                <span>${moment(date).format('DD-MM YYYY HH:mm')}</span>`;
        },
        ...mapActions(['getAudiences','getChannels'])
    },
    computed: {
        columns() {
            return [
                { data: 'id', visible: false },
                { title: this.resource('AudienceModel_Created_DisplayName'), data: 'created', render: (data) => {
                    return this.htmlDateField(data);
                }},
                { title: this.resource('AudienceModel_Modified_DisplayName'), data: 'modified', render: (data) => {
                    return this.htmlDateField(data);
                }},
                { title: this.resource('AudienceModel_Name_DisplayName'), data: 'name'},
                { title: this.resource('AudienceModel_Description_DisplayName'), data: 'description'},
                { title: this.resource('AudienceModel_LastModifiedBy_DisplayName'), data: 'lastModifiedBy'},
                { title: this.resource('AudienceModel_Channels_DisplayName'), data: 'channels', render: (data) => {
                    return data && data.length > 0 ? data.join(', ') : '-';
                }}
            ];
        },
        newAudienceRoute() {
            return RouteNames.NEW_AUDIENCE;
        },
        ...mapState(['audiences'])
    }
};